import * as React from 'react';
import merge from 'lodash/merge';
import { Theme,  createTheme, Components } from '@mui/material/styles';

import { AppThemeComponents, AppThemeProvider } from '@egr/xbox/egr-gui-elements/AppThemeProvider/AppThemeProvider';
import { OpenSansFontFaces } from '@egr/xbox/fonts/openSans/OpenSansImport';
import { wcfGUITypography, wcfGUIOverrides, wcfGUIPalette, getBaseTheme } from '@egr/xbox/egr-gui-elements/Helper/MUIOverrides';

const fontFamily: string = '"Open Sans", sans-serif';
const mainSecondaryColor: string = '#4F4F4F';
export const mainPrimaryColor: string = '#E60023';

const baseTheme: Theme = getBaseTheme(wcfGUIPalette(mainPrimaryColor, mainSecondaryColor));

const kompanWalkthroughTheme: Theme = createTheme({
    ...baseTheme,
    typography: {
        ...wcfGUITypography,
        fontFamily
    },
    components: merge<Components, Components>(
        wcfGUIOverrides(baseTheme),
        {
            MuiCssBaseline: {
                styleOverrides: {
                    ...OpenSansFontFaces,
                    '.nipple .back': {
                        background: 'url(./img/controller_back.svg) no-repeat center center transparent !important',
                        height: '130px !important',
                        marginLeft: '-65px !important',
                        marginTop: '-65px !important',
                        opacity: '1 !important',
                        width: '130px !important'
                    },
                    '.nipple .front': {
                        background: 'url(./img/controller_front.svg) no-repeat center center transparent !important',
                        height: '60px !important',
                        marginLeft: '-30px !important',
                        marginTop: '-30px !important',
                        opacity: '1 !important',
                        width: '60px !important'
                    },
                    body: {
                        msOverflowStyle: '-ms-autohiding-scrollbar',
                        '@media (-ms-high-contrast: none)': {
                            msOverflowStyle: 'auto'
                        },
                        '@supports (-ms-ime-align:auto)': {
                            msOverflowStyle: 'auto'
                        },
                        fontFamily: baseTheme.typography.fontFamily,
                        '@media print': {
                            // Save printer ink.
                            backgroundColor: baseTheme.palette.common.white,
                        },
                    }
                }
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        fontWeight: 400,
                    },
                    textPrimary: {
                        color: mainPrimaryColor
                    }
                }
            },
            MuiAppBar: {
                defaultProps: {
                    elevation: 0
                },
                styleOverrides: {
                    colorDefault: {
                        borderBottom: 0,
                    },
                }
            },
            MuiPopover: {
                styleOverrides: {
                    paper: {
                        '& > *': {
                            overflow: 'hidden'
                        }
                    }
                }
            },
            MuiDialog: {
                styleOverrides: {
                    paper: {
                        '&:not($paperFullScreen)': {
                            maxHeight: 'calc(100% - 64px)',
                        },
                    },
                }
            },
            MuiButtonBase: {
                defaultProps: {
                    disableRipple: true
                }
            }
        }
    ),
});

const appThemeComponents: AppThemeComponents = {
    imagePlaceholder: null,
    loadingImagePlaceholder: null,
    productPlaceholder: null,
    projectPlaceholder: null,
};

export const KompanPlannerThemeProvider: React.FC = React.memo(
    (props: React.PropsWithChildren<{}>) => {
        return (
            <AppThemeProvider
                lightTheme={kompanWalkthroughTheme}
                darkTheme={kompanWalkthroughTheme}
                useBottomSheet={false}
                {...appThemeComponents}
            >
                {props.children}
            </AppThemeProvider>
        );
    }
);